(() => {
  if (customElements.get('velodrom-social-gallery')) return;
  customElements.define('velodrom-social-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      if (this.dataset.feedUrl) this.loadInstagram(this.controller);
      this.expiryTimer = setInterval(() => {
        for (const link of this.querySelectorAll('[data-story-expires]')) {
          if (Date.parse(link.dataset.storyExpires) > Date.now()) continue;
          if (this.opener === link && this.dialog?.open) this.dialog.close();
          link.closest('article')?.remove();
        }
        const row = this.querySelector('.vsg__stories'); if (row && !row.children.length) row.hidden = true;
      }, 60000);
      this.dialog = this.querySelector('dialog');
      this.detail = this.querySelector('.vsg__detail');
      if (!this.dialog || !this.detail || !this.dialog.showModal) return;
      this.storyControls = this.querySelector('.vsg__story-controls');
      this.querySelector('[data-story-prev]')?.addEventListener('click', () => this.stepStory(-1), options);
      this.querySelector('[data-story-next]')?.addEventListener('click', () => this.stepStory(1), options);
      this.dialog.addEventListener('keydown', event => { if (this.opener?.dataset.storyExpires && ['ArrowLeft','ArrowRight'].includes(event.key)) { event.preventDefault(); this.stepStory(event.key === 'ArrowLeft' ? -1 : 1); } }, options);
      this.addEventListener('click', (event) => {
        const link = event.target.closest('[data-vsg-card]');
        if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0) return;
        const template = [...this.querySelectorAll('template')].find(item => item.dataset.vsgTemplate === link.dataset.vsgCard);
        if (!template) return;
        event.preventDefault();
        if (link.dataset.storyExpires && Date.parse(link.dataset.storyExpires) <= Date.now()) { link.closest('article')?.remove(); return; }
        this.opener = link;
        this.dialog.dataset.story = String(Boolean(link.dataset.storyExpires));
        if (this.storyControls) {
          this.storyControls.hidden = !link.dataset.storyExpires;
          const stories = [...this.querySelectorAll('[data-story-expires]')].filter(item => Date.parse(item.dataset.storyExpires) > Date.now());
          const index = stories.indexOf(link);
          this.querySelector('[data-story-position]').textContent = `${index + 1} / ${stories.length}`;
          this.querySelector('[data-story-prev]').disabled = index <= 0;
          this.querySelector('[data-story-next]').disabled = index >= stories.length - 1;
        }
        this.detail.querySelectorAll("video").forEach(video => video.pause());
        this.detail.replaceChildren(template.content.cloneNode(true));
        if (!this.dialog.open) this.dialog.showModal();
        this.dialog.querySelector('.vsg__close').focus();
      }, options);
      this.querySelector('.vsg__close').addEventListener('click', () => this.dialog.close(), options);
      this.dialog.addEventListener('click', (event) => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
      }, options);
      this.dialog.addEventListener('close', () => {
        this.detail.querySelectorAll('video').forEach(video => video.pause());
        this.detail.replaceChildren();
        this.opener?.focus();
      }, options);
    }
    stepStory(direction) {
      const stories = [...this.querySelectorAll('[data-story-expires]')].filter(link => Date.parse(link.dataset.storyExpires) > Date.now());
      stories[stories.indexOf(this.opener) + direction]?.click();
    }
    async loadInstagram(controller) {
      const grid = this.querySelector('.vsg__grid');
      const hadCards = Boolean(grid?.children.length);
      if (!grid) return;
      if (!hadCards) this.hidden = true;
      try {
        const endpoint = new URL(this.dataset.feedUrl);
        if (!['https:', 'http:'].includes(endpoint.protocol)) return;
        if (this.dataset.collection) endpoint.searchParams.set('collection', this.dataset.collection);
        const fetchController = new AbortController();
        const abortFetch = () => fetchController.abort();
        controller.signal.addEventListener('abort', abortFetch, { once: true });
        const timer = setTimeout(abortFetch, 12000);
        let data;
        try {
          const response = await fetch(endpoint, { signal: fetchController.signal, credentials: 'omit' });
          if (!response.ok) throw new Error('feed_unavailable');
          data = await response.json();
        } finally {
          clearTimeout(timer);
          controller.signal.removeEventListener('abort', abortFetch);
        }
        if (!Array.isArray(data.posts) || controller.signal.aborted) return;
        const filter = (this.dataset.captionFilter || '').trim().toLowerCase();
        const cards = document.createDocumentFragment();
        const storyCards = document.createDocumentFragment();
        const stories = this.dataset.storiesEnabled === 'true' && Array.isArray(data.stories) ? data.stories.filter(post => Date.parse(post.expiresAt) > Date.now()) : [];
        for (const post of [...data.posts.slice(0,24), ...stories]) {
          const isStory = post.source === 'story';
          if (filter && !String(post.caption || '').toLowerCase().includes(filter)) continue;
          const permalink = new URL(post.permalink);
          if (permalink.protocol !== 'https:' || !['www.instagram.com','instagram.com'].includes(permalink.hostname)) continue;
          const variants = (post.images || []).filter(image => /^\/instagram\/images\/[a-f0-9]{20}-(240|480|900)\.webp$/.test(image.url));
          if (!variants.length) continue;
          const cover = variants[variants.length-1];
          const label = String(post.caption || (isStory ? `Story · ${new Date(post.timestamp).toLocaleString()}` : 'Velodrom / Instagram'));
          const card = document.createElement('article'); card.className = isStory ? 'vsg__story' : 'vsg__card';
          const link = document.createElement('a'); link.className = 'vsg__open';
          if (isStory) link.dataset.storyExpires = post.expiresAt;
          link.href = permalink.href; link.dataset.vsgCard = 'instagram-' + post.id; link.setAttribute('aria-label',label.slice(0,200));
          const image = document.createElement('img'); image.src = new URL(cover.url, endpoint).href;
          image.srcset = variants.map(variant => `${new URL(variant.url, endpoint).href} ${variant.width}w`).join(', ');
          image.sizes = isStory ? '88px' : `(min-width:990px) ${100/(Number(this.dataset.columns)||6)}vw, (min-width:750px) 33vw, 50vw`;
          image.width = cover.width; image.height = cover.height; image.alt = label.slice(0,200); image.loading = 'lazy'; image.decoding = 'async';
          link.append(image);
          const discover = document.createElement('span'); discover.className = 'vsg__discover'; discover.textContent = isStory ? 'Story' : this.dataset.discover || 'Discover'; link.append(discover);
          const template = document.createElement('template'); template.dataset.vsgTemplate = link.dataset.vsgCard;
          const media = document.createElement('div'); media.className = 'vsg__media';
          let videoUrl;
          try { const url = new URL(post.video); if (url.protocol === 'https:' && ['cdninstagram.com','fbcdn.net'].some(host => url.hostname.endsWith('.'+host) || url.hostname === host)) videoUrl = url.href; } catch {}
          if (videoUrl && !data.stale) {
            const play = document.createElement('span'); play.className = 'vsg__play'; play.textContent = '▶'; play.setAttribute('aria-hidden','true'); link.append(play);
            const video = document.createElement('video'); video.className = 'vsg__video'; video.src = videoUrl; video.poster = image.src; video.controls = true; video.playsInline = true; video.preload = 'none'; media.append(video);
          } else {
            const full = image.cloneNode(); full.sizes = '(min-width:750px) 65vw, 100vw'; media.append(full);
          }
          const copy = document.createElement('div'); copy.className = 'vsg__copy';
          const caption = document.createElement('p'); caption.textContent = label; if (!isStory || post.caption) copy.append(caption);
          for (const product of post.products || []) {
            if (!/^[a-z0-9-]+$/.test(product.handle || '')) continue;
            const productLink = document.createElement('a'); productLink.className = 'vsg__product';
            productLink.href = '/products/' + product.handle;
            if (product.image) { try {
              const url = new URL(product.image);
              if (url.protocol === 'https:' && url.hostname === 'cdn.shopify.com') {
                url.searchParams.set('width', '160'); const thumb = document.createElement('img'); thumb.src = url.href; thumb.alt = ''; thumb.width = 80; thumb.height = 80; thumb.loading = 'lazy'; productLink.append(thumb);
              }
            } catch {} }
            const title = document.createElement('span'); title.textContent = `${product.title} — ${this.dataset.shopLabel || 'Shop this product'} ↗`; productLink.append(title); copy.append(productLink);
          }
          const original = document.createElement('a'); original.className = 'vsg__instagram'; original.href = permalink.href;
          original.target = '_blank'; original.rel = 'noopener noreferrer'; original.textContent = (this.dataset.instagramLabel || 'View on Instagram') + ' ↗'; copy.append(original);
          template.content.append(media,copy); card.append(link,template); (isStory ? storyCards : cards).append(card);
        }
        const hasStories = storyCards.childNodes.length > 0;
        const row = this.querySelector('.vsg__stories');
        if (row) { row.replaceChildren(storyCards); row.hidden = !hasStories; }
        if (hasStories) this.hidden = false;
        if (cards.childNodes.length) {
          grid.replaceChildren(cards); this.querySelector('[data-vsg-empty]')?.remove(); this.hidden = false;
        }
      } catch { /* Retain curated fallback or hide an empty gallery during an outage. */ }
    }
    disconnectedCallback() {
      this.dialog?.close();
      this.detail?.querySelectorAll('video').forEach(video => video.pause());
      clearInterval(this.expiryTimer);
      this.controller?.abort();
      this.controller = null;
    }
  });
})();
